module.exports = __webpack_public_path__ + "img/goumaiqudao.28568b32.png";